<template>
    <div class="container mb-5">
        <div class="row justify-content-center">
            <div class="col-md-6">
                <div class="card card-default">
                    <div class="card-header"><strong>Make a payment</strong></div>

                    <div class="card-body" style="color:#000;">

                        <p class="alert alert-danger" v-if="errors.length">
                            <b>Please correct the following error(s):</b>
                            <ul class="mb-0">
                                <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
                            </ul>
                        </p>
                                                
                        <p class="alert alert-success" v-if="success">
                            <b>{{ message }}</b>
                        </p>

                        <div v-if="!success">

                            <fieldset class="form-group">
                                <label for="name">Account Name</label>
                                <input type="text" v-model="name" class="form-control">
                            </fieldset>
                            <fieldset class="form-group">
                                <label for="stripeEmail">Email</label>
                                <input type="email" v-model="stripeEmail" class="form-control">
                            </fieldset>
                            <div class="row">
                            <fieldset class="form-group col-6">
                                <label for="amount">Amount</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">$</span>
                                    </div>
                                    <input type="text" size="6" v-model="amount" class="form-control" >
                                </div>
                            </fieldset>
                            </div>
                            <fieldset class="form-group">
                                <label for="note">Note</label>
                                <textarea v-model="note" rows="3" class="form-control"></textarea>
                            </fieldset>
                            <fieldset class="form-group text-center">
                                <button class="btn btn-primary" @click.prevent="checkForm">Submit</button>
                            </fieldset>
                        
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: ['stripeKey'],

        created() {
            let vm = this;
            this.stripe = StripeCheckout.configure({
                key: this.stripeKey,
                // image: "/img/stripe-checkout.jpg",
                locale: "auto",
                token: function (token){
                    vm.stripeToken = token.id;
                    // vm.stripeEmail = token.email;
                    // document.querySelector('#stripeToken').value = token.id;
                    // document.querySelector('#stripeEmail').value = token.email;
                    // document.querySelector('#subscription_form').submit();
                    axios.post('/payments', vm.$data)
                        .then(response => {
                            console.log(response);
                            if(response.data.error === true){
                                vm.errors.push(response.data.message);
                            } else {
                                vm.message = response.data.message;
                                vm.success = true;
                                vm.charge_id = response.data.charge_id;
                            }
                        });
                }
            });
        },

        methods: {

            complete(data){
                comsole.log(data);
                comsole.log(data.message);
            },

            pay(){
                this.stripe.open({
                    name: 'Horne Radio',
                    email: this.stripeEmail,
                    description: 'Payment for ' + this.name,
                    zipCode: true,
                    amount: this.amount * 100
                });
            },


            checkForm: function (e) {
                e.preventDefault();
                this.errors = [];

                if (!this.name) {
                    this.errors.push("Name required.");
                }

                if (!this.stripeEmail) {
                    this.errors.push('Email required.');
                } 
                // else if (!this.validEmail(this.email)) {
                //     this.errors.push('Valid email required.');
                // }

                if(isNaN(this.amount)){
                    this.errors.push('Valid dollar amount required.');
                }

                if(this.amount < 5){
                    this.errors.push('Minimum payment $5.00.');
                }

                if (!this.errors.length) {
                    this.pay();
                }

            },

            validEmail: function (email) {
                var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
                return re.test(email);
            }

        },

        data(){
            return {
                stripeEmail: null,
                name:null,
                amount: 0,
                note: null, 
                stripeToken: null,
                message: null,
                errors:[],
                success: null,
                charge_id: null
            }
        },
        
        computed: {

            isNum(){
                if(isNaN(this.amount)){
                    return false;
                }
                return true;
            },

        },

    }
</script>
